import api from "@/lib/api";

export type PostGoogleReCaptchaRequest = {
  token: string;
  version: "v2" | "v3";
};

export type PostGoogleReCaptchaResponse = {
  isBot: boolean;
};

export default {
  postGoogleReCaptcha(data: PostGoogleReCaptchaRequest) {
    return api<PostGoogleReCaptchaRequest, PostGoogleReCaptchaResponse>({
      endpoint: "google/web-api/re-captcha",
      method: "POST",
      body: data
    });
  }
};
